import styled from "styled-components/macro"
import Color from "../../../constants/Color"

export const Container = styled.div`
  width: 100%;
  height: auto;
  padding: 12px 16px;

  @media (min-width: 640px) {
    padding: 18px 0;
  }
`
export const Header = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  @media (min-width: 640px) {
    flex-direction: row;
  }
`
export const Left = styled.div`
  flex: 1;
  margin-bottom: 12px;
`
export const Right = styled.div`
  flex: 1;
  display: flex;
  justify-content: end;
  align-items: center;
`
export const Tab = styled.button`
  border: none;
  outline: none;
  margin-right: 12px;
  padding: 8px 16px;
  font-size: 18px;
  font-weight: ${({ active }) => (active ? "bold" : "normal")};
  color: ${Color.gray600};
  background: ${({ active }) => (active ? Color.gray100 : "transparent")};
  border-radius: 6px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;

  @media (min-width: 768px) {
    font-size: 20px;
  }
`

export const Search = styled.input`
  position: relative;
  width: 100%;
  padding: 10px 12px;
  font-size: 16px;
  border: 1px solid ${Color.gray300};
  color: ${Color.gray600};
  border-radius: 4px;
  outline: none;

  @media (min-width: 768px) {
    width: 60%;
  }
`

export const Body = styled.div`
  width: 100%;
  padding: 12px 0;
  display: grid;
  grid-template-columns: repeat(6, minmax(100px, 1fr));
  grid-gap: 16px;
  position: relative;

  @media screen and (max-width: 1024px) {
    grid-template-columns: repeat(4, minmax(100px, 1fr));
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(3, minmax(100px, 1fr));
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }

  @media screen and (max-width: 375px) {
    grid-template-columns: repeat(1, 1fr);
  }

  @media (min-width: 1280px) {
    grid-gap: 32px;
  }
`
export const ErrorBody = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (min-width: 768px) {
    height: 400px;
  }
`
export const NoDataFound = styled.div`
  width: 100%;
  height: 317px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const NotFoundText = styled.p`
  font-size: 18px;
  color: #dc2626;
  text-align: center;
`
